
export class associateDocList {
    id:number;
    firstName :string="";
    lastName :string="";
    streamId :string="";
    collegeId :string="";
    enrollmentNo :string=""; 
    passingYearId :string="";
    branchId :string="";
    semId :string="";
    monthOfPassing:string="";
    originalDOCuploadfilePath :string;
    }